export const genericAction = (actionName: string) => {
    return (payload: any, onSuccess?: (...args: any) => void, onFail?: (...args: any) => void) => ({
      type: actionName,
      payload,
      onSuccess: onSuccess || null,
      onFail: onFail || null,
    }
    )
  };
  